// CareCard.tsx — the CARE prompt ("process your triggered emotions…"), shown in the
// new Today AFTER a settle session rather than as a persistent feed notification.
// White card with a dark-green action, matching the arrival "title box" style.
import { C, SP, R, F, SIZE, W, eyebrow } from './theme';
import { CARE_PROMPT_TITLE, CARE_PROMPT_SUBTITLE } from '@/data/care';

export function CareCard({ onOpen, onDismiss }: { onOpen: () => void; onDismiss: () => void }) {
  return (
    <section style={{ background: C.surface, borderRadius: R.xl, padding: '16px 16px 15px', marginTop: SP.md, boxShadow: '0 8px 26px rgba(0,0,0,0.08)' }}>
      <div style={{ ...eyebrow, color: C.brandDark }}>After settling</div>
      <h2 style={{ fontFamily: F.title, fontSize: SIZE.h3, fontWeight: W.medium, lineHeight: 1.25, color: C.text, margin: '5px 0 0' }}>{CARE_PROMPT_TITLE}</h2>
      <p style={{ fontFamily: F.ui, fontSize: SIZE.body, lineHeight: 1.5, color: C.textBody, margin: '8px 0 13px' }}>{CARE_PROMPT_SUBTITLE}</p>
      <div style={{ display: 'flex', gap: SP.sm, alignItems: 'center' }}>
        <button onClick={onOpen} style={{ background: '#1f7d5e', color: '#fff', border: 'none', borderRadius: R.md, padding: '11px 18px', cursor: 'pointer', fontFamily: F.ui, fontSize: SIZE.md, fontWeight: W.semibold }}>Begin</button>
        <button onClick={onDismiss} style={{ background: 'none', border: 'none', color: C.textMuted, cursor: 'pointer', fontFamily: F.ui, fontSize: SIZE.md, fontWeight: W.semibold, padding: '11px 10px' }}>Not now</button>
      </div>
    </section>
  );
}
